import React, {useEffect} from 'react';

import {useApi} from "../../providers/ApiProvider";

import ProfilePhotoCard from "./ProfilePhotoCard";
import ChangePasswordCard from "./ChangePasswordCard";
import PersonalInfoCard from "./PersonalInfoCard";
import UsersRequests from "../../requests/UsersRequests";
import {useBreadcrumbs} from "../../providers/BreadcrumbsProvider";
import {useAuth} from "../../providers/AuthProvider";

function AccountInfoTab(props) {
    const {user} = useAuth();
    const apiContext = useApi();
    const usersRequests = new UsersRequests(apiContext.api);
    const breadcrumbs = useBreadcrumbs();

    const [personalInfo, setPersonalInfo] = React.useState({
        name: '',
        email: '',
        avatar: '',
        settings: {}
    });
    const resetPersonalInfo = () => {
        usersRequests.view(user.id).then((response) => {
            if (response !== false) {
                setPersonalInfo({
                    name: response.name,
                    email: response.email,
                    avatar: response.avatar,
                    settings: response.settings
                });

                let currentUser = localStorage.getItem('user');
                if (currentUser) {
                    currentUser = JSON.parse(currentUser);
                    currentUser.name = response.name;
                    currentUser.email = response.email;
                    currentUser.avatar = response.avatar;
                    currentUser.settings = response.settings;
                } else {
                    currentUser = {
                        name: response.name,
                        email: response.email,
                        avatar: response.avatar,
                        settings: response.settings
                    }
                }

                localStorage.setItem('user', JSON.stringify(currentUser));
            }
        });
    }


    useEffect(() => {
        resetPersonalInfo();
    }, []);


    return (
        <div className="row">
            <div className="col-lg-4 d-flex align-items-stretch">
                <ProfilePhotoCard
                    personalInfo={personalInfo}
                    resetPersonalInfo={resetPersonalInfo}
                />
            </div>
            <div className="col-lg-4 d-flex align-items-stretch">
                <PersonalInfoCard
                    usersRequests={usersRequests}
                    name={personalInfo.name}
                    email={personalInfo.email}
                    settings={personalInfo.settings}
                    resetPersonalInfo={resetPersonalInfo}
                />
            </div>
            <div className="col-lg-4 d-flex align-items-stretch">
                <ChangePasswordCard
                    usersRequests={usersRequests}
                />
            </div>
        </div>
    );
}

export default AccountInfoTab;
